var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-engelska';
                    var viewUrl = 'gfx/sprite.svg#view-icon-engelska';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 18 17',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };